import React, { useEffect, useState } from "react"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import { listComponents, deleteComponent, pauseComponent } from "../api"
import ComponentEditor from "./ComponentEditor"

const ComponentList = ({ projectId }) => {
  const [components, setComponents] = useState([])
  const [loading, setLoading] = useState(false)
  const [editing, setEditing] = useState(null)

  const refresh = async () => {
    setLoading(true)
    const r = await listComponents(projectId)
    setComponents(r?.components || [])
    setLoading(false)
  }

  useEffect(() => { refresh() }, [projectId])

  const onDelete = async (c) => {
    if (!confirm(`Delete component "${c.name}"? This removes all its checks.`)) return
    await deleteComponent(c._id)
    refresh()
  }

  const togglePause = async (c) => {
    const paused = c.pausedUntil && new Date(c.pausedUntil) > new Date()
    if (paused) await pauseComponent(c._id, null, true)
    else await pauseComponent(c._id, new Date(Date.now() + 60 * 60 * 1000).toISOString())
    refresh()
  }

  if (editing !== null) {
    return (
      <ComponentEditor
        projectId={projectId}
        component={editing}
        onClose={() => { setEditing(null); refresh() }}
      />
    )
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <Typography variant="admin_h3">Components</Typography>
        <Button onClick={() => setEditing({})}>New component</Button>
      </div>
      {loading && <div>Loading...</div>}
      {!loading && components.length === 0 && <div className="text-text_secondary">No components yet.</div>}
      <div className="grid gap-2">
        {components.map((c) => {
          const paused = c.pausedUntil && new Date(c.pausedUntil) > new Date()
          return (
            <div key={c._id} className="p-3 rounded-lg bg-paper border border-bordered flex items-center justify-between">
              <div className="min-w-0">
                <div className="font-medium truncate">{c.name}</div>
                <div className="text-xs text-text_secondary truncate">{c.environment}{paused ? " · PAUSED" : ""} · {(c.tags || []).join(", ")}</div>
              </div>
              <div className="flex gap-2">
                <Button variant="secondary" onClick={() => togglePause(c)}>{paused ? "Resume" : "Pause"}</Button>
                <Button variant="secondary" onClick={() => setEditing(c)}>Edit</Button>
                <Button variant="danger" onClick={() => onDelete(c)}>Delete</Button>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ComponentList
